import { Content } from '../types';

let __CONTENT_LOADING = false;
let __CONTENT_DATA: Content | null = null;
let __CONTENT_PROMISE: Promise<Content | null> | null = null;

export async function fetchContentJson(): Promise<Content | null> {
    if (__CONTENT_DATA) return __CONTENT_DATA;
    if (__CONTENT_LOADING && __CONTENT_PROMISE) return __CONTENT_PROMISE;

    __CONTENT_LOADING = true;

    const version = Date.now();
    const paths = [`content.json?v=${version}`, `/content.json?v=${version}`];

    __CONTENT_PROMISE = (async () => {
        for (const p of paths) {
            try {
                const res = await fetch(p, { cache: 'no-store' });
                if (!res.ok) {
                    console.warn('Content fetch attempt failed');
                    continue;
                }
                const data = await res.json();
                __CONTENT_DATA = data as Content;
                __CONTENT_LOADING = false;
                return data;
            } catch (err) {
                console.warn('Content fetch error');
            }
        }
        __CONTENT_LOADING = false;
        return null;
    })();

    return __CONTENT_PROMISE;
}

export function getContent(): Content | null {
    return __CONTENT_DATA;
}
